import { LaunchDarklyContext } from '@afterpaytouch/feature'
import React, { ReactElement, ReactNode, useCallback } from 'react'
import { shallowEqual } from 'react-redux'
import { clearFeatureFlags, setFeatureFlagState, useAppDispatch, useAppSelector } from '../state'
import { getUserContext } from '../utils/object'

interface CheckoutLaunchDarklyContextProps {
  children?: ReactNode
}

export const CheckoutLaunchDarklyContext = ({ children }: CheckoutLaunchDarklyContextProps): ReactElement => {
  const dispatch = useAppDispatch()
  const userProps = useAppSelector(getUserContext, shallowEqual)

  const handleLoad = useCallback((): void => {
    dispatch(setFeatureFlagState(false))
    dispatch(clearFeatureFlags())
  }, [dispatch])

  const handleDone = useCallback((): void => {
    dispatch(setFeatureFlagState(true))
  }, [dispatch])

  return (
    <LaunchDarklyContext userProps={userProps} onLoad={handleLoad} onDone={handleDone}>
      {children}
    </LaunchDarklyContext>
  )
}
